import ErrorIcon from '@mui/icons-material/Error';
import { Stack } from '@mui/material';
import React from 'react';

import { MobileBody } from '../Typography';

export interface ErrorStateProps {
  message?: string;
  sx?: object;
}

const ErrorState: React.FC<ErrorStateProps> = ({
  message = 'Ocurrió un error al cargar.',
  sx,
}) => {
  return (
    <Stack
      direction="column"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      sx={{
        width: '100%',
        minHeight: '200px',
        display: 'flex',
        ...sx,
      }}
    >
      <ErrorIcon
        sx={{
          color: 'text.secondary',
          fontSize: '2rem',
          textAlign: 'center',
        }}
      />
      <MobileBody color="text.secondary" sx={{ textAlign: 'center' }}>
        {message}
      </MobileBody>
    </Stack>
  );
};

export default ErrorState;
